import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { FiLoader } from "react-icons/fi";

import {
  getReport,

} from "../../redux/ReduxSlices/candidateSlice";
import { getHistoryData } from "../../redux/ReduxSlices/managerSlice";

import CertificatePopup from "../certificate/Certificate";




const StudentReport = () => {


  const [range, setRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { historyData, loading, error } = useSelector((state) => state.manager);
 
  const startDate = range[0].startDate;
  const endDate = range[0].endDate;

  const [containerHeight, setContainerHeight] = useState(300);
  const [isLoading, setIsLoading] = useState(false);
  const [showCertificate, setShowCertificate] = useState(false);
  const [certificateDetails, setCertificateDetails] = useState(null);

  useEffect(() => {
    dispatch(getHistoryData());
  }, [dispatch]);

  

  const filteredDataByDate = historyData.filter((entry) => {
    const entryDate = new Date(entry._id.date.split(" ")[0]);
    const fromDate = startDate ? new Date(startDate) : null;
    const toDate = endDate ? new Date(endDate) : null;

    if (entryDate) entryDate.setHours(0, 0, 0, 0);
    if (fromDate) fromDate.setHours(0, 0, 0, 0);
    if (toDate) toDate.setHours(0, 0, 0, 0);

    return (
      (!fromDate || entryDate >= fromDate) && (!toDate || entryDate <= toDate)
    );
  });

  useEffect(() => {
    const updateHeight = () => {
      if (window.innerWidth < 768) {
        setContainerHeight(250); // Mobile
      } else {
        setContainerHeight(300); // Desktop / Tablet
      }
    };

    updateHeight(); // Set initially

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // optional: sort by date

  const handleReport = (candidate) => {
    const id = candidate.candidate_pk;
    dispatch(getReport(id));
    navigate(`/viewreport/${id}`);
  };

  const handleViewCertificate = (candidate) => {
    const formattedDate = new Date(
      candidate.exam_completed_at
    ).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const capitalize = (str) =>
      typeof str === "string" && str.length > 0
        ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
        : "";
    const name =
      capitalize(candidate.first_name?.text || candidate.first_name) +
      " " +
      capitalize(candidate.last_name?.text || candidate.last_name);

    setCertificateDetails({
      name,
      score: candidate.current_role_fit_score,
      id: candidate.candidate_pk?.slice(0, 8),
      issue_date: formattedDate,
    });

    setShowCertificate(true);
  };

  const sendButtonClicked = () => {
    navigate("/individual-assessment");
  };
  return (
    <div className="min-h-screen px-6 max-md:p-0">
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
          <FiLoader className="animate-spin text-[#822bda] text-4xl" />
        </div>
      )}

      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
          <FiLoader className="animate-spin text-[#822bda] text-4xl" />
        </div>
      )}

      {/* Filtered Table */}
      <motion.div
        className="max-w-8xl mx-auto py-4 max-md:px-0"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        {filteredDataByDate.length === 0 ? (
          <div className="text-center text-gray-500 mt-32 text-sm my-10">
            <p className="text-center text-2xl text-gray-500 mt-32 mb-4">
              No assessment records found
            </p>
            <p className="text-gray-400 mb-4">
              Take the assessment — your full results and insights will show up
              right here
            </p>
            <button
              className="mt-2 inline-flex items-center gap-2 px-6 py-1 border border-violet-400 text-violet-600 text-sm font-semibold rounded-md shadow-md hover:bg-violet-500 hover:text-white hover:shadow-lg transition-all duration-200 ease-in-out active:scale-95"
              onClick={sendButtonClicked}
            >
              Starts New Assessment
            </button>
          </div>
        ) : (
          <div className="overflow-x-auto rounded-lg">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg">
              <thead>
                <tr className="bg-purple-100 text-sm">
                  <th className="p-2 text-left">Date</th>
                  <th className="p-2 text-left">Name</th>
                  <th className="p-2 text-left">Score</th>
                  <th className="p-2 text-left">Has Started</th>
                  <th className="p-2 text-left">Has Completed</th>
                  <th className="p-2 text-left">Report Status</th>
                  <th className="p-2 text-left">Download Certificate</th>
                  <th className="p-2 text-left">View Report</th>
                </tr>
              </thead>
              <tbody>
                {filteredDataByDate.map((entry, index) => {
                  const rawUTC = entry._id.date;
                  const userTimeZone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                  // Force parse as UTC
                  const utcDate = new Date(
                    rawUTC.endsWith("Z")
                      ? rawUTC
                      : rawUTC.replace(" ", "T") + "Z"
                  );
                  // Convert to local time zone
                  const localDate = utcToZonedTime(utcDate, userTimeZone);
                  // Format as per local time
                  const formattedDate = format(
                    localDate,
                    "dd MMM yyyy, hh:mm a"
                  );

                  return entry.candidates.map((candidate) => (
                    <tr
                      key={candidate.candidate_pk}
                      className="border-t border-gray-200 text-sm hover:bg-gray-50"
                    >
                      <td className="p-3">{formattedDate}</td>
                      <td className="p-3">
                        {candidate.first_name && candidate.last_name
                          ? `${capitalize(candidate.first_name)} ${capitalize(
                              candidate.last_name
                            )}`
                          : candidate.email === null
                          ? "-"
                          : candidate.email}
                      </td>
                      <td className="p-3">
                        {candidate.current_role_fit_score === null
                          ? "-"
                          : candidate.current_role_fit_score}
                      </td>
                      <td className="p-3">
                        {candidate.is_assessment_started === false
                          ? "No"
                          : "Yes"}
                      </td>
                      <td className="p-3">
                        {candidate.is_assessment_completed === false
                          ? "No"
                          : "Yes"}
                      </td>
                      <td className="p-3">
                        <span
                          className={`px-3 max-md:px-1 py-1 rounded-full text-sm max-md:text-xs font-medium ${
                            candidate.is_report_generated === "pending"
                              ? "bg-yellow-400 text-white"
                              : candidate.is_report_generated === "processing"
                              ? "bg-blue-400 text-white"
                              : candidate.is_report_generated === "success"
                              ? "bg-green-500 text-white"
                              : candidate.is_report_generated === "failed"
                              ? "bg-red-500 text-white"
                              : ""
                          }`}
                        >
                          {candidate.is_report_generated
                            .charAt(0)
                            .toUpperCase() +
                            candidate.is_report_generated.slice(1)}
                        </span>
                      </td>
                      <td className="p-3">
                        {candidate.is_report_generated === "success" ? (
                          <span
                            className="text-green-700 font-bold text-sm max-md:text-xs cursor-pointer"
                            // onClick={() => setShowCertificate(true)}
                            onClick={() => handleViewCertificate(candidate)}
                          >
                            View Certificate
                          </span>
                        ) : (
                          <span className="text-sm max-md:text-xs font-semibold text-gray-500">
                            Awating result
                          </span>
                        )}
                      </td>
                      <td className="p-3">
                        {candidate.is_report_generated === "success" ? (
                          <span
                            className="text-green-700 font-bold text-sm max-md:text-xs cursor-pointer"
                            onClick={() => handleReport(candidate)}
                          >
                            View Report
                          </span>
                        ) : (
                          <span className="text-sm max-md:text-xs font-semibold text-gray-500">
                            Pending
                          </span>
                        )}
                      </td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>
        )}
      </motion.div>
      {showCertificate && (
        <CertificatePopup
          certificateDetails={certificateDetails}
          onClose={() => setShowCertificate(false)}
        />
      )}
    </div>
  );
};

export default StudentReport;
